<script setup>
import { Head, router } from '@inertiajs/vue3';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import InputField from '@js/components/fields/InputField.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { toastError, toastSuccess } from '@js/utils/toast';
import { Form } from 'vee-validate';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { route } = useRoute();

const isSubmitting = ref(false);

const form = reactive({
    email: '',
});

const validationSchema = object({
    email: string()
        .required('Le champ email est requis')
        .email('Le champ doit être un email valide'),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(route('front.postForgotPassword'), {
            email: form.email,
        })
        .then((response) => {
            if (response.data.status === 'passwords.sent') {
                toastSuccess(
                    "Un lien de réinitialisation de mot de passe a été envoyé à l'adresse email " +
                        form.email,
                );

                router.visit(route('front.login'));
            } else if (response.data.status === 'passwords.throttled') {
                toastError(
                    'Un email de réinitialisation de mot de passe a déjà été envoyé. Veuillez vérifier votre boîte de réception.',
                );
            } else if (response.data.status === 'passwords.user') {
                toastError(
                    "Aucun utilisateur n'a été trouvé avec cette adresse email.",
                );
            } else {
                toastError('Une erreur est survenue.');
            }
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            toastError(error);
        });
}
</script>

<template>
    <Head>
        <title>Mot de passe oublié - Datakepler</title>
    </Head>

    <div
        class="flex h-full flex-col items-center justify-center bg-gray-100 p-4"
    >
        <img
            src="/images/logo/logo.svg"
            alt="Datakepler"
            class="mb-6 w-48 md:w-60"
        />

        <Form
            v-slot="{ errors }"
            :validation-schema="validationSchema"
            class="w-full max-w-md rounded border border-gray-200 bg-white p-6"
            @submit="submit"
        >
            <PageTitle>Mot de passe oublié</PageTitle>

            <InputField
                v-model="form.email"
                label="Email"
                field-name="email"
                field-id="email"
                type="email"
                required
            />

            <div class="mt-6">
                <ActionButton
                    submit
                    :disabled="Object.keys(errors).length > 0 || isSubmitting"
                    class="w-full"
                    size="large"
                    :loading="isSubmitting"
                >
                    Réinitialiser le mot de passe
                </ActionButton>
            </div>
        </Form>
    </div>
</template>
